export default {
  globalNotifications: {},
  localNotifications: {},
};
